import { isQueryStringOptionFromFilter } from '@modules/common/utils';
import { NestedQueryStringOptions } from '@modules/common/utils/transformWhereClauseToFieldNameValues';
import { Box, Divider, Stack, Typography } from '@mui/material';
import { OperationType } from 'v2/core/services/queryBuilder/whereClause';
import { SimpleFilterPreview } from './SimpleFilterPreview';

export const NestedFilterPreview = ({
  filterData,
  conjunction,
  shouldHideTooltips = false,
}: {
  filterData: NestedQueryStringOptions;
  conjunction?: OperationType;
  shouldHideTooltips?: boolean;
}) => {
  return (
    <Stack>
      <Typography variant="subtitle2" color="text.secondary">
        {conjunction}
      </Typography>
      <Stack direction="row">
        <Divider
          orientation="vertical"
          variant="middle"
          flexItem
          sx={{ height: 'auto !important', margin: '0 8px 0 0' }}
        />
        <Box width="100%">
          {filterData.params?.map((param, index) => {
            if (!param) {
              return null;
            }

            const isSimpleFilter = isQueryStringOptionFromFilter(param);

            return isSimpleFilter ? (
              <SimpleFilterPreview
                key={index}
                filterData={param}
                conjunction={index > 0 ? filterData.conjunction : undefined}
                fieldDisplayName={param.fieldDisplayName}
                shouldHideTooltips={shouldHideTooltips}
              />
            ) : (
              <NestedFilterPreview
                key={index}
                filterData={param}
                conjunction={index > 0 ? filterData.conjunction : undefined}
                shouldHideTooltips={shouldHideTooltips}
              />
            );
          })}
        </Box>
      </Stack>
    </Stack>
  );
};
